import {Row, Col, Container, Button} from 'react-bootstrap';
import Site from '../components/Site';
import { useGetSitesQuery } from '../slices/sitesApiSlice';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const SiteScreen = () => {
  const navigate = useNavigate();
  const {userInfo} = useSelector((state) => state.auth);

  const {data: sites, isLoading, error} = useGetSitesQuery(undefined, {
    skip: !userInfo
  });

  useEffect(() => {
      if(!userInfo){
          navigate('/login');
      }
  }, [userInfo, navigate])

  if (!userInfo) {
    return null;
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Outfit:wght@300;400;500;600;700;800&display=swap');

        .modern-sites-container {
          color: #ffffff;
          font-family: 'Outfit', 'Inter', sans-serif;
          max-width: 1300px;
          margin: 0 auto;
          padding: 20px;
        }

        .sites-header-block {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 30px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
          padding-bottom: 20px;
        }

        .sites-tag {
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 2px;
          color: #00cec9;
          text-transform: uppercase;
          margin-bottom: 4px;
        }

        .sites-title {
          font-size: 32px;
          font-weight: 700;
          background: var(--theme-gradient-light);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0;
        }

        .sites-subtitle {
          font-size: 14px;
          color: #b2bec3;
          margin: 5px 0 0 0;
        }

        .modern-sites-container a {
          text-decoration: none !important;
          color: inherit !important;
          display: block;
        }

        .modern-sites-container a:hover {
          text-decoration: none !important;
        }

        .modern-sites-container .btn-add-site {
          background: var(--theme-gradient) !important;
          border: none !important;
          border-radius: 10px !important;
          color: #ffffff !important;
          font-weight: 600 !important;
          padding: 10px 20px !important;
          box-shadow: 0 4px 15px rgba(184, 134, 11, 0.25) !important;
          transition: all 0.2s ease !important;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          text-decoration: none !important;
        }

        .modern-sites-container .btn-add-site:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 6px 20px rgba(184, 134, 11, 0.4) !important;
          opacity: 0.95;
          color: #ffffff !important;
        }
      `}</style>

      <div className="modern-sites-container">
        {isLoading ? (
          <div className="text-center py-5">
            <h2 className="text-white">Loading Sites Directory...</h2>
          </div>
        ) : error ? (
          <div className="alert alert-danger">
            {error?.data?.message || error.error || "An error occurred."}
          </div>
        ) : (
          <Container fluid className="px-0">
            {/* Header Block */}
            <div className="sites-header-block flex-column flex-md-row align-items-start align-items-md-end gap-3">
              <div>
                <div className="sites-tag">Sites Directory</div>
                <h1 className="sites-title">Active Sites & Locations</h1>
                <p className="sites-subtitle">
                  Browse and manage physical locations, network nodes, and contact details across the organization.
                </p>
              </div>
              <div>
                <Button as={Link} to="/sites/add" className="btn-add-site">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="me-1">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                  Add New Site
                </Button>
              </div>
            </div>

            {/* Sites Grid */}
            <Row className="g-4">
              {sites.map((site) => (
                <Col key={site._id} sm={12} md={6} lg={4} xl={3}>
                  <Site site={site} />
                </Col>
              ))}
            </Row>
          </Container>
        )}
      </div>
    </>
  );
};

export default SiteScreen;
